export const campaignType = {
  HOBBII: 'hobbii'
};
